import { BaseQueryDTO } from './basequery-dto';

export class QueryUpdateExternalCommentReadStatusDTO extends BaseQueryDTO {
    Ids: number[];
    IsRead: boolean;
}
